import React from 'react';
import { Link } from 'react-router-dom';

import './Footer.css';

const Footer = props => {
  return <footer className="footer">{props.children}   
   <div className="leftFooter"><a href="https://www.aegean.gr/" target="new"><img src="/logo_circle_white.png"   height="80" width="80"/></a></div>
   <div className="middleFooter"> Click <Link to="/about">here</Link> for more information about GeoLODRecommender</div>
   <div className="rightFooter"><a href="http://cartogi-lab.aegean.gr/index.php/en/" target="new"><img src="/cartolab.png" height="60" width="300"/></a>
   <br/>Design &amp; Development by <a href="http://cartogi-lab.aegean.gr/index.php/en/" target="new">CartoGI-Lab</a> @ 2020
   </div>
  </footer>;
};

export default Footer;
